import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-progress-clock',
  standalone: false,
  templateUrl: './icon-progress-clock.html',
  styleUrl: './icon-progress-clock.scss',
})
export class IconProgressClockComponent {
  @Input() tooltip?: string;
}
